import { render, staticRenderFns } from "./linkmanList.vue?vue&type=template&id=31dd3baa&scoped=true&"
import script from "./linkmanList.vue?vue&type=script&lang=js&"
export * from "./linkmanList.vue?vue&type=script&lang=js&"
import style0 from "./linkmanList.vue?vue&type=style&index=0&id=31dd3baa&prod&lang=scss&scoped=true&"
import style1 from "./linkmanList.vue?vue&type=style&index=1&id=31dd3baa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd3baa",
  null
  
)

export default component.exports